import { createVNode as _createVNode2, createTextVNode as _createTextVNode, Fragment as _Fragment2 } from "vue";
import "core-js/modules/es.symbol.description.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5974f9e1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "board"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fadeInUp",
  wait: "200"
}, "产品亮点", -1));
const _hoisted_3 = {
  key: 0,
  class: "fixbox"
};
const _hoisted_4 = {
  class: "pic fadeInRight"
};
const _hoisted_5 = ["data"];
const _hoisted_6 = {
  class: "context fadeInLeft"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "fixbox"
};
const _hoisted_9 = {
  class: "pic"
};
const _hoisted_10 = ["data"];
const _hoisted_11 = {
  class: "context"
};
const _hoisted_12 = {
  class: "title"
};
import { ref, reactive, watch, onMounted } from 'vue';
import { isMobile, tabHoverIndex, observe } from '@/utils';
// 产品亮

export default {
  __name: 'index',
  setup(__props) {
    const data = reactive([{
      key: 't1',
      title: '身份意愿双重确认',
      imgSrc: require('@/assets/img/identity.svg'),
      description: () => _createVNode2(_Fragment2, null, [_createVNode2("p", null, [_createTextVNode("\u6570\u5B57\u7B14\u8FF9\u751F\u7269\u7279\u5F81\u4E0D\u4EC5\u80FD\u8BC6\u522B\u8EAB\u4EFD\uFF0C\u7B7E\u7684\u4E3B\u52A8\u884C\u4E3A\u672C\u8EAB\u5C31\u662F\u610F\u613F\u786E\u8BA4\u8868\u8FBE\u3002\u57FA\u4E8E\u5176\u7279\u6709\u7684\u751F\u7269\u7279\u5F81\u548C\u884C\u4E3A\u7279\u5F81\u5F3A\u5173\u8054\u5C5E\u6027\uFF0C\u5B9E\u73B0\u8EAB\u4EFD\u610F\u613F\u786E\u8BA4\u7684\u5408\u4E8C\u4E3A\u4E00\u3002")]), _createVNode2("p", null, [_createVNode2("ul", {
        "class": "light-dot"
      }, [_createVNode2("li", null, [_createTextVNode("\u7B14\u8FF9\u751F\u7269\u8BC6\u522B")]), _createVNode2("li", null, [_createTextVNode("\u6570\u5B57\u8EAB\u4EFD\u6807\u8BC6")]), _createVNode2("li", null, [_createTextVNode("\u5F3A\u610F\u613F\u8868\u8FBE")]), _createVNode2("li", null, [_createTextVNode("\u5408\u89C4\u4E14\u4FBF\u6377")])])])])
    }, {
      key: 't2',
      title: '实现电子档单套制',
      imgSrc: require('@/assets/img/e-contract.svg'),
      description: () => _createVNode2(_Fragment2, null, [_createVNode2("p", null, [_createTextVNode("\u6E90\u5934\u53BB\u7EB8\uFF0C\u5168\u7A0B\u7535\u5B50\u5316\u6D41\u8F6C\uFF0C\u5230\u5355\u5957\u5236\u7535\u5B50\u6863\u6848\u5F52\u6863\uFF0C\u5F62\u6210\u5168\u6D41\u7A0B\u6570\u5B57\u5316\u8BC1\u636E\u95ED\u73AF\uFF0C\u786E\u4FDD\u7535\u5B50\u4EF6\u5373\u539F\u4EF6\uFF0C\u6EE1\u8DB3\u7535\u5B50\u6863\u6848\u771F\u5B9E\u6027\u3001\u5B8C\u6574\u6027\u3001\u53EF\u7528\u6027\u3001\u5B89\u5168\u6027\u3002")]), _createVNode2("p", null, [_createVNode2("ul", {
        "class": "light-dot"
      }, [_createVNode2("li", null, [_createTextVNode("\u5168\u7A0B\u53BB\u7EB8\u5316")]), _createVNode2("li", null, [_createTextVNode("\u5B9E\u65F6\u53EF\u67E5\u9605")]), _createVNode2("li", null, [_createTextVNode("\u8BC1\u636E\u7535\u5B50\u5316")]), _createVNode2("li", null, [_createTextVNode("\u5168\u6D41\u7A0B\u95ED\u73AF")])])])])
    }, {
      key: 't3',
      title: '应用场景全面覆盖',
      imgSrc: require('@/assets/img/secec.svg'),
      description: () => _createVNode2(_Fragment2, null, [_createVNode2("p", null, [_createTextVNode("\u7B14\u8FF9\u8BC6\u522B\u7535\u5B50\u5316\u7B7E\u7F72\u4ECE\u7EB8\u8D28\u8F7D\u4F53\u53D8\u6210\u7535\u5B50\u5316\u7B7E\u7F72\u8BBE\u5907\uFF0C\u4E0E\u7EB8\u8D28\u6587\u4EF6\u7684\u8EAB\u4EFD\u8BA4\u8BC1\u4E0E\u610F\u613F\u8868\u8FBE\u903B\u8F91\u4E00\u81F4\uFF0C\u652F\u6301\u8FDC\u7A0B\u7B7E\u7F72\u3001\u8DE8\u5E73\u53F0\u3001\u8DE8\u5730\u57DF\u5168\u573A\u666F\u5E94\u7528\u843D\u5730\u3002")]), _createVNode2("p", null, [_createVNode2("ul", {
        "class": "light-dot"
      }, [_createVNode2("li", null, [_createTextVNode("\u8FDC\u7A0B\u7B7E\u7F72\u4E0D\u53D7\u9650")]), _createVNode2("li", null, [_createTextVNode("\u573A\u666F\u9002\u7528\u6027\u9AD8")]), _createVNode2("li", null, [_createTextVNode("\u8DE8\u5730\u57DF\u8DE8\u8BBE\u5907")]), _createVNode2("li", null, [_createTextVNode("\u52A9\u529B\u964D\u672C\u589E\u6548")])])])])
    }, {
      key: 't4',
      title: '创新技术去密码化',
      imgSrc: require('@/assets/img/chuangxin.svg'),
      description: () => _createVNode2(_Fragment2, null, [_createVNode2("p", null, [_createTextVNode("\u5C06\u7B14\u8FF9\u751F\u7269\u7279\u5F81\u5F62\u6210\u5BC6\u94A5\uFF0C\u5F3A\u5173\u8054\u751F\u7269\u7279\u5F81\uFF0C\u5F3A\u8C03\u7279\u5F81\u4E00\u81F4\uFF0C\u65E0\u9700\u8BB0\u5FC6\u3001\u4E0D\u6613\u9020\u4F2A\u3001\u968F\u65F6\u53EF\u9A8C\u8BC1\uFF0C\u4FDD\u62A4\u7528\u6237\u4E2A\u4EBA\u4FE1\u606F\u548C\u52A0\u5F3A\u6570\u636E\u5B89\u5168\uFF0C\u6210\u4E3A\u4F20\u7EDF\u5BC6\u7801\u7EC8\u7ED3\u8005\u3002")]), _createVNode2("p", null, [_createVNode2("ul", {
        "class": "light-dot"
      }, [_createVNode2("li", null, [_createTextVNode("\u65E0\u9700\u8BB0\u5FC6\u9632\u9057\u5FD8")]), _createVNode2("li", null, [_createTextVNode("\u4E0D\u6613\u4F2A\u9020\u53EF\u9A8C\u8BC1")]), _createVNode2("li", null, [_createTextVNode("\u6570\u636E\u4FDD\u8BC1\u4E0D\u5916\u6CC4")]), _createVNode2("li", null, [_createTextVNode("\u5F3A\u8EAB\u4EFD\u5173\u8054")])])])])
    }]);
    const tab2 = ref('t1');
    const tabs = ref(null);
    onMounted(() => {
      if (!isMobile() && tabs.value) {
        tabHoverIndex(tabs.value, index => {
          const key = 't' + (index + 1);
          if (tab2.value !== key) {
            tab2.value = key;
          }
        });
      }
      const _tabs = [...document.querySelectorAll('.board .ant-tabs-nav')];
      _tabs.forEach((target, idx) => {
        target.className += ' fadeInUp';
        if (idx === _tabs.length - 1) {
          target.setAttribute('wait', '200');
        }
      });
    });
    watch(tab2, nv => {
      setTimeout(() => {
        observe(['.board .fadeInUp']);
      });
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_var_tab_item = _resolveComponent("var-tab-item");
      const _component_var_tabs_items = _resolveComponent("var-tabs-items");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_a_tabs, {
        activeKey: tab2.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => tab2.value = $event),
        centered: "",
        ref_key: "tabs",
        ref: tabs,
        "force-render": true
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data, ({
          description,
          ...item
        }) => {
          return _openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.key,
            tab: item.title,
            forceRender: true
          }, {
            default: _withCtx(() => [!_unref(isMobile)() ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("object", {
              type: "image/svg+xml",
              data: item.imgSrc
            }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1), (_openBlock(), _createBlock(_resolveDynamicComponent(description())))])])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["tab"]);
        }), 128))]),
        _: 1
      }, 8, ["activeKey"]), _unref(isMobile)() ? (_openBlock(), _createBlock(_component_var_tabs_items, {
        key: 0,
        active: tab2.value,
        "onUpdate:active": _cache[1] || (_cache[1] = $event => tab2.value = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data, ({
          description,
          ...item
        }) => {
          return _openBlock(), _createBlock(_component_var_tab_item, {
            key: item.key,
            name: item.key
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("object", {
              type: "image/svg+xml",
              data: item.imgSrc
            }, null, 8, _hoisted_10)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1), (_openBlock(), _createBlock(_resolveDynamicComponent(description())))])])]),
            _: 2
          }, 1032, ["name"]);
        }), 128))]),
        _: 1
      }, 8, ["active"])) : _createCommentVNode("", true)]);
    };
  }
};